module.exports = __webpack_public_path__ + "static/hero-welder-02-ecb62f46aa82e38dd413ed8881e9ee92.jpg";